
var env = process.env;

var config = window.config||{};

export const base = config.base;
export const server_base = config.server_base;

export const APP_NAME = config.appName;

export const APP_TITLE = config.appTitle;

export const AUTHORITY = config.oidc.authority;
export const CLIENT_ID = config.oidc.client_id;
export const REDIRECT_URI = config.oidc.redirect_uri;
export const RESPONSE_TYPE = config.oidc.response_type;
export const SCOPE = config.oidc.scope;
export const POST_LOGOUT_REDIRECT_URI = config.oidc.post_logout_redirect_uri;


export default {
  authority: AUTHORITY,
  client_id: CLIENT_ID,
  redirect_uri: REDIRECT_URI,
  response_type: RESPONSE_TYPE,
  scope: SCOPE,
  post_logout_redirect_uri: POST_LOGOUT_REDIRECT_URI
};



// WEBPACK FOOTER //
// ./src/common/config.js